import React, { useEffect, useState } from "react";
// API req //
import { fetchDataDrugs, fetchVocabulary } from "../api-call/api";
// serialize and deserialize from URL //
import {
  deserialize_and_pick,
  serialize,
  extract_matchers,
} from "../data/serialization";
// componrnts //
import DrugCard from "./card/Card";
import SelectInput from "./forms/select";
// 3 input fields matches //
import {
  theme_matches,
  drugname_matches,
  type_matches,
} from "../matchers/matchers";
// helper functions//
import { get_api_urls, get_initial_drugs } from "../helper/helpers";
// material-ui //
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

const extract_value = (e) => e.value;
const extract_id = (e) => e.id;

const state = {
  // The elements inside these arrays are taken directly
  // from the API response. For instance, a drug looks like this:
  //
  drug_name: [],
  illness: [],
  type: [],
};

export default function Main() {
  // data holds data about all drugs that will be shown in the cards
  const [drugs, setDrugs] = useState();
  // result holds the result of the API vocabulary query
  const [vocabularies, setVocabularies] = useState();
  // filteredArray is a filtered version of data
  const [filteredArray, setFilteredArray] = useState();
  // Used to initialize form Selects only once
  const [isInitialized, setIsInitialized] = useState(false);

  const urls = get_api_urls();

  async function fetchDataDrugsAPI() {
    try {
      const result = await fetchDataDrugs(urls.api_url, urls.api_key);
      setDrugs(result);
    } catch (err) {
      return err;
    }
  }
  async function fetchVocabularyAPI() {
    try {
      const result = await fetchVocabulary(
        urls.api_vocabulary_url,
        urls.api_key
      );

      setVocabularies(result);
    } catch (err) {
      return err;
    }
  }

  useEffect(() => {
    async function __fetch() {
      await Promise.all([fetchDataDrugsAPI(), fetchVocabularyAPI()]);
    }
    __fetch();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /* select options */
  let drugNameOptions = [];
  const topicsNameOptions = [];

  if (vocabularies) {
    for (const item of vocabularies["atc_codes"]) {
      drugNameOptions.push({
        value: item.title,
        label: item.title,
        id: item.title,
      });
      const seen = new Set();
      const filterNames = drugNameOptions.filter((el) => {
        const duplicate = seen.has(el.value);
        seen.add(el.value);
        return !duplicate;
      });
      drugNameOptions = filterNames;
    }

    for (const item of vocabularies["topics"]) {
      if (item.id === "199") {
        continue;
      }
      topicsNameOptions.push({
        value: item.title,
        label: item.title,
        id: item.id,
      });
    }
  }
  const typeDocumentOptions = [
    {
      label: "Frühe Nutzenbewertung",
      value: "Frühe Nutzenbewertungen",
      id: "drug-assessment",
    },
    { label: "Fact Sheet", value: "Factsheets", id: "drug-factsheet" },
    {
      label: "Wechselwirkungen und Nebenwirkungen",
      value: "Wechselwirkungen und Nebenwirkungen",
      id: "drug-interaction",
    },
  ];
  /* end the react options here */

  /* update the card list here */
  const updateFilteredArray = (fieldname) => (values, action) => {
    if (values && values.length) {
      state[fieldname] = values;
    } else state[fieldname] = [];
    const url_to_state_map = {
      topics: "illness",
      document_type: "type",
      title: "drug_name",
    };
    const url_string_components = [];
    for (let [url_name, state_name] of Object.entries(url_to_state_map)) {
      if (state[state_name].length === 0) {
        continue;
      }
      url_string_components.push(
        url_name + "=" + encodeURIComponent(serialize(state[state_name]))
      );
    }
    const url_string = url_string_components.join("&");
    if (window.parent !== window && isInitialized) {
      window.parent.history.replaceState(null, null, "?" + url_string);
    }
    const show_card = (item) =>
      drugname_matches(item, state.drug_name) &&
      theme_matches(item, state.illness) &&
      type_matches(state.type.map(extract_value), item);

    setFilteredArray(drugs.filter(show_card));
  };

  const is_expanded = (item) => {
    if (
      state.drug_name.length === 0 &&
      state.illness.length === 0 &&
      state.type.length === 0
    ) {
      return false;
    }
    return true;
  };

  var form = <></>;
  if (
    drugNameOptions.length > 0 &&
    drugs &&
    drugs.length > 0 &&
    typeDocumentOptions.length > 0
  ) {
    if (!isInitialized) {
      var params = new URLSearchParams(window.location.hash.substr(1));

      if (params.get("title") !== null) {
        state.drug_name = extract_matchers(
          params.get("title"),
          drugNameOptions
        );
        updateFilteredArray("drug_name")(state.drug_name);
      } else {
        const initial_drugs = get_initial_drugs();
        state.drug_name = drugNameOptions.filter((el) =>
          initial_drugs.includes(el.label.toLocaleLowerCase())
        );
        updateFilteredArray("drug_name")(state.drug_name);
      }

      state.illness = deserialize_and_pick(
        params.get("topics"),
        topicsNameOptions
      );
      updateFilteredArray("illness")(state.illness);

      state.type = deserialize_and_pick(
        params.get("document_type"),
        typeDocumentOptions
      );
      updateFilteredArray("type")(state.type);

      setIsInitialized(true);
    }

    form = (
      <section className="select-input">
        <SelectInput
          className="drugs"
          name="drugs"
          options={drugNameOptions}
          placeholder="Arzneimittel"
          defaultValue={state.drug_name}
          onChange={updateFilteredArray("drug_name")}
        />
        <SelectInput
          className="topics"
          name="topics"
          options={topicsNameOptions}
          placeholder="Indikation"
          defaultValue={state.illness}
          onChange={updateFilteredArray("illness")}
        />
        <SelectInput
          className="type"
          name="type"
          options={typeDocumentOptions}
          placeholder="Dokumenttyp"
          defaultValue={state.type}
          onChange={updateFilteredArray("type")}
        />
      </section>
    );
  }

  return (
    <main>
      {form}
      <div className="cards">
        {!isInitialized ? (
          <CircularProgress disableShrink />
        ) : filteredArray && filteredArray.length > 0 ? (
          filteredArray.map((el) => (
            <DrugCard
              key={el.anchor}
              el={el}
              types={state.type.map(extract_value)}
              assessments={state.illness.map(extract_id)}
              should_expand={is_expanded(el)}
            />
          ))
        ) : (
          <Typography component="p">
            Keine Ergebnisse gefunden, bitte passen Sie den Filter an.
          </Typography>
        )}
      </div>
    </main>
  );
}
